export default function LoadingMapCard() {
  return (
    <div className='flex gap-4 justify-between w-full animate-pulse h-screen/2 p-5'>
      {/* <div className="w-1/4 h-full flex flex-col justify-between gap-5">
        <div className="h-1/2 w-full space-y-5">
          <div className="bg-neutralColor-light h-6 w-full rounded-md"></div>
          <div className="w-1/2 bg-neutralColor-light h-4 rounded-md"></div>
          <LoadingCircularAvatar />
        </div>
        <div className="w-full space-y-10">
          <div className="flex justify-between w-full">
            <span className="h-4 w-1/2 bg-neutralColor-light rounded-md"></span>
            <span className="h-4 w-1/3 bg-neutralColor-light rounded-md"></span>
          </div>
          <div className="flex justify-between w-full">
            <span className="h-4 w-1/3 bg-neutralColor-light rounded-md"></span>
            <span className="h-4 w-1/2 bg-neutralColor-light rounded-md"></span>
          </div>
          <div className="flex justify-between w-full">
            <span className="h-4 w-2/3 bg-neutralColor-light rounded-md"></span>
            <span className="h-4 w-1/4 bg-neutralColor-light rounded-md"></span>
          </div>
          <div className="flex justify-between w-full">
            <span className="h-4 w-1/3 bg-neutralColor-light rounded-md"></span>
            <span className="h-4 w-1/3 bg-neutralColor-light rounded-md"></span>
          </div>
        </div>
      </div> */}
      <div className='w-full h-full bg-neutralColor-light rounded-md'></div>
    </div>
  );
}
